module.exports = __webpack_public_path__ + "img/logo.f6d3213a.png";